import React, { useEffect, useState } from "react";

//Import Mui
import Alert from "../controls/MuiSnackbarAlert";

//Import from navItemsSlice.js
import { updateUserCredential } from "./navItemsSlice";

//Import from loginSlice.js
import {
  getSignInUser,
  getSignInUserFromServer,
} from "../registration/signin/loginSlice";

//Import Redux
import { useDispatch, useSelector } from "react-redux";

//Import React Router Dom
import { useNavigate } from "react-router-dom";

import profileImg from "../../images/MARFish.png";
import "./nav.css";
import { unwrapResult } from "@reduxjs/toolkit";

const NavAvatar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const signInUser = useSelector(getSignInUser);

  //useState
  const [loginUser, setLoginUser] = useState(signInUser);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    severity: "",
  });
  //useState

  useEffect(() => {
    if (loginUser === null) {
      dispatch(getSignInUserFromServer())
        .then(unwrapResult)
        .then((result) => {
          if (result.status === "error") {
            setLoginUser("");
            setNotify({
              isOpen: true,
              message: result.data,
              severity: "error",
            });
            return;
          } else {
            setLoginUser(result.data);
          }
        });
    }
  }, []);

  const handleLogout = async (signinUser) => {
    await dispatch(updateUserCredential(signinUser))
      .then(unwrapResult)
      .then((result) => {
        if (result.flag === 1) {
          setNotify({
            isOpen: true,
            message: result.message,
            severity: "success",
          });
          sessionStorage.clear();
          setTimeout(function () {
            navigate("/");
          }, 1000);
        } else {
          setNotify({
            isOpen: true,
            message: result.message,
            severity: "error",
          });
        }
      });
  };

  return (
    <>
      <Alert notify={notify} setNotify={setNotify} />

      <li className="nav-item dropdown pe-3">
        <a
          className="nav-link nav-profile d-flex align-item-center pe-0"
          href="#"
          data-bs-toggle="dropdown"
        >
          {/* src={profileImg} */}
          <img src={profileImg} alt="profile" className="rounded-circle" />
          <span className="d-none d-md-block dropdown-toggle ps-2">
            {loginUser}
          </span>
        </a>

        <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
          <li className="dropdown-header">
            <h6>MAR Fish</h6>
            <span>Wholesale / Retailer</span>
          </li>
          <li>
            <hr className="dropdown-divider"></hr>
          </li>

          <li>
            <a className="dropdown-item d-flex align-item-center">
              <i className="bi bi-person"></i>
              <span>My Profile</span>
            </a>
          </li>
          <li>
            <hr className="dropdown-divider"></hr>
          </li>

          <li>
            <a className="dropdown-item d-flex align-item-center">
              <i className="bi bi-gear"></i>
              <span>Account Settings</span>
            </a>
          </li>
          <li>
            <hr className="dropdown-divider"></hr>
          </li>

          <li>
            <a className="dropdown-item d-flex align-item-center">
              <i className="bi bi-question-circle"></i>
              <span>Need Help?</span>
            </a>
          </li>
          <li>
            <hr className="dropdown-divider"></hr>
          </li>

          <li>
            <a className="dropdown-item d-flex align-item-center">
              <i className="bi bi-box-arrow-right"></i>
              <span onClick={() => handleLogout(loginUser)}>Sign Out</span>
            </a>
          </li>
        </ul>
      </li>
    </>
  );
};

export default NavAvatar;
